import React from 'react';

import { Box } from '@mui/material';

import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useRegisterPageRefreshHandler } from '../../../../components/layout/page-container/page-refresh-handler';
import LoadMoreFeedback from '../../../../components/reusable/load-more-feedback/LoadMoreFeedback';
import TrainingList from '../training-list/TrainingList';
import { useMyTrainingsPage } from './useMyTrainingsPage';

interface IMyTrainingsProps {
  tabsHidden: boolean;
  setPlanDialogOpen: (open: boolean) => void;
  onStartEmptyTrainingClick: () => void;
}

const MyTrainings = (props: IMyTrainingsProps) => {
  const { tabsHidden, setPlanDialogOpen, onStartEmptyTrainingClick } = props;
  const {
    trainings,
    filter,
    setFilter,
    isLoading,
    onAddNewTrainingClicked,
    onGenerateTrainingClick,
    onStartClick,
    isAddButtonVisible,
    footerRef,
    isFetching,
    error,
    retryLastRequest,
    refetchAll,
    resetAll,
  } = useMyTrainingsPage({ setPlanDialogOpen, onStartEmptyTrainingClick });

  useRegisterPageRefreshHandler(() => resetAll(true));

  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading,
    hasData: Boolean(trainings?.length),
    onRetry: retryLastRequest,
  });

  return (
    <TrainingList
      tabsHidden={tabsHidden}
      listKind="my"
      trainings={trainings}
      searchValue={filter}
      onSearchChange={setFilter}
      isLoading={isLoading}
      addNewTrainingClicked={
        isAddButtonVisible ? onAddNewTrainingClicked : undefined
      }
      generateTrainingClicked={onGenerateTrainingClick}
      startClicked={isAddButtonVisible ? onStartClick : undefined}
      onStartExistingTrainingRestricted={() => setPlanDialogOpen(true)}
      onTrainingDeleted={refetchAll}
      listFooter={
        <>
          <LoadMoreFeedback
            error={error}
            isFetching={isFetching}
            onRetry={retryLastRequest}
          />
          <Box ref={footerRef} mb={1} />
        </>
      }
    />
  );
};

export default MyTrainings;
